var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7_488)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2358 20.1809C36.2358 29.3335 28.8162 36.7532 19.6636 36.7532C10.511 36.7532 3.09131 29.3335 3.09131 20.1809C3.09131 11.0283 10.511 3.60864 19.6636 3.60864C28.8162 3.60864 36.2358 11.0283 36.2358 20.1809ZM38.2358 20.1809C38.2358 30.4381 29.9208 38.7532 19.6636 38.7532C9.40639 38.7532 1.09131 30.4381 1.09131 20.1809C1.09131 9.92373 9.40639 1.60864 19.6636 1.60864C29.9208 1.60864 38.2358 9.92373 38.2358 20.1809ZM16.782 11.2939C16.2297 11.2939 15.782 11.7416 15.782 12.2939V17.9H13.6562C12.7765 17.9 12.3254 18.9541 12.9328 19.5905L18.9402 25.884C19.3342 26.2967 19.993 26.2967 20.387 25.884L26.3944 19.5905C27.0018 18.9541 26.5507 17.9 25.671 17.9H23.5453V12.2939C23.5453 11.7416 23.0976 11.2939 22.5453 11.2939H16.782ZM12.3833 28.6743C12.3833 28.0115 12.9207 27.4741 13.5835 27.4741H25.7436C26.4064 27.4741 26.9438 28.0115 26.9438 28.6743C26.9438 29.3372 26.4064 29.8745 25.7436 29.8745H13.5835C12.9206 29.8745 12.3833 29.3372 12.3833 28.6743Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7_488",
    x: 0.0913086,
    y: 0.608643,
    width: 39.1445,
    height: 39.1445,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0257032 0 0 0 0 0.128516 0 0 0 0 0 0 0 0 0.76 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7_488"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7_488",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon_download.ec476f210a1add9b4e02265af84bb046.svg";
export { ForwardRef as ReactComponent };